var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"boton-validaciones"}},[_c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[_c('v-flex',{attrs:{"lg12":""}},[_c('v-card',[_c('boton-proceso-tab-validaciones',{attrs:{"lstBtn":_vm.lstBtn}})],1),(_vm.loading)?_c('div',[_c('loading')],1):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }